import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/ibs-2023-walkthrough")({
  beforeLoad: () => {
    throw redirect({ to: "/demo/photoreal-walkthrough", statusCode: 301 });
  },
});
